import { useEffect } from "react";

export const useGrabbingCursor = (condition: boolean) => {
  useEffect(() => {
    document.body.style.cursor = condition ? "grabbing" : "";

    return () => {
      document.body.style.cursor = "";
    };
  }, [condition]);
};
